import { render, staticRenderFns } from "./business-view.vue?vue&type=template&id=0151ddcd&scoped=true"
import script from "./business-view.vue?vue&type=script&lang=js"
export * from "./business-view.vue?vue&type=script&lang=js"
import style0 from "./business-view.vue?vue&type=style&index=0&id=0151ddcd&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0151ddcd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0151ddcd')) {
      api.createRecord('0151ddcd', component.options)
    } else {
      api.reload('0151ddcd', component.options)
    }
    module.hot.accept("./business-view.vue?vue&type=template&id=0151ddcd&scoped=true", function () {
      api.rerender('0151ddcd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hotel/business-view.vue"
export default component.exports